module.exports = __webpack_public_path__ + "socicon.cf2fcbeb5bbb509e50e6.svg";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/socicon/socicon.svg
// module id = ../../../../../src/assets/vendors/base/fonts/socicon/socicon.svg
// module chunks = styles